import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import cx from 'classnames'

import Logo from '../logo'
import NavButton from '../nav-button'

import { openNav, setNavHeight, openAboutSection } from '../../../actions'

import './header.scss'

class Header extends Component {

    state = {
        isNavOpen: false   
    }

  constructor (props) {
      super(props)

      this.navRef = React.createRef()
  }

  componentDidMount () {
    const navHeight = this.navRef.current.getBoundingClientRect().height
    this.props.dispatch(setNavHeight(navHeight))
  }

  onMouseDown = e => {
      if (e.target.nodeName === 'A') {
        this.props.dispatch(openNav(false))
      }
  }

  openNav = e => {
      this.setState({ isNavOpen: !this.state.isNavOpen })
      e.target.innerText = !this.state.isNavOpen ? 'Close' : 'About'
      this.props.dispatch(openAboutSection(!this.state.isNavOpen))
  }

  render() {
    const { darkTheme, isAboutOpen, navIsOpen } = this.props
    const { isNavOpen } = this.state

    const className = cx(
        'app-header',
        'container-fluid',
        { 'dark-theme': darkTheme },
        { 'is-about-open': isNavOpen }
    )
    const buttonClassName = cx(
        { 'highlight': isNavOpen }
    )

    const containerStyle = isAboutOpen ? { 
        transform: `translate3d(-450px, 0, 0)`
    } : {}

    return (
        <header style={containerStyle} className={className}>
            <Logo isFooter={darkTheme} />

            <NavButton />

            <nav 
                className={cx({ 'shown': navIsOpen })}
                onMouseDown={this.onMouseDown}
                ref={this.navRef}>
                <ul>
                    <li>
                        <Link to="/all/anywhere/1">Go Back</Link>
                    </li>
                    <li>
                        <Link className="highlight" to="/claim-profile">Claim your profile</Link>
                    </li>
                    <li>
                        <a href="mailto:directory@delight-vr.com">Contact</a>
                    </li>
                    <li>
                        <button 
                            className={buttonClassName} onClick={this.openNav}>About</button>
                    </li>
                </ul>
            </nav>
        </header>     
    )
  }
}

export default connect(state => ({
    isAboutOpen: state.uiReducer.isAboutOpen,
    navIsOpen: state.uiReducer.isNavOpen
}))(Header)


// WEBPACK FOOTER //
// ./src/components/shared/header/index.jsx